import styles from './css/PasswordRecoveryWrapper.css';

import React from 'react';
import { Link } from '@tcc/crate';
import { getMessage } from '../../i18n/i18nWrapper';
import propTypes from 'prop-types';

const GLOBAL_SUPPORT_CONTACT_URL = 'https://climate.com/about/contact#locations';
const BLURB_TEST_ID = 'password-recovery-blurb';

const PasswordRecoveryWrapper =
  ({supportEmail, supportPhoneNumber, isCountryKnown}) => (isCountryKnown)
    ? (<p className={styles.helpComment} data-test-id={BLURB_TEST_ID}>
      {getMessage('passwordWrapper.blurb',
        {email: supportEmail, phone: supportPhoneNumber})}
    </p>)
    : (<p className={styles.helpComment} data-test-id={BLURB_TEST_ID}>
      <span>{getMessage('passwordWrapper.blurb.unknownCountry')}</span>
      <Link href={GLOBAL_SUPPORT_CONTACT_URL} testId='global-support'>
        {getMessage('passwordWrapper.globalSupportLink')}
      </Link>
    </p>);

PasswordRecoveryWrapper.propTypes = {
  isCountryKnown: propTypes.bool.isRequired,
  supportEmail: propTypes.string.isRequired,
  supportPhoneNumber: propTypes.string.isRequired
};

export default PasswordRecoveryWrapper;
